module.exports = __webpack_public_path__ + "img/fi-street-food-400x263.2a3954a9.jpg";